import { useAppService } from "../state";

export const useIsLsu = (): boolean => {
  const [{ currentEvent }] = useAppService();

  return /^lsu/i.test(currentEvent?.promoCode ?? "");
};
